"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getSortItinerary = getSortItinerary;
exports.getSortPriceDurationHashMap = getSortPriceDurationHashMap;
exports.getTopScoreItineraries = getTopScoreItineraries;
exports.getTopScoreItinerary = getTopScoreItinerary;
exports.initializeSortState = initializeSortState;
exports.sort = sort;
var _orderBy2 = _interopRequireDefault(require("lodash/orderBy"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _minBy2 = _interopRequireDefault(require("lodash/minBy"));
var _find3 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _sort = require("../../constants/sort.constants");
function sort(results, sortKey) {
  var _find2 = (0, _find3.default)(_sort.SORT_BY_MAP, function (item) {
      return item.key === sortKey;
    }),
    sortBy = _find2.sortBy,
    orderBy = _find2.orderBy;
  return (0, _orderBy2.default)(results, sortBy, orderBy);
}
function getTopScoreItinerary(itineraries, sortKey) {
  var minItinerary = (0, _minBy2.default)(itineraries, sortKey);
  return {
    id: (0, _get2.default)(minItinerary, "id", 0),
    price: (0, _get2.default)(minItinerary, "displayPrice.total", 0),
    itinerary: minItinerary
  };
}
function getTopScoreItineraries(itineraries) {
  return {
    recommended: getTopScoreItinerary(itineraries, _sort.SORT_BY_MAP.BEST.sortBy),
    cheapest: getTopScoreItinerary(itineraries, _sort.SORT_BY_MAP.CHEAPEST.sortBy),
    shortest: getTopScoreItinerary(itineraries, _sort.SORT_BY_MAP.SHORTEST.sortBy),
    cheapestDirect: getTopScoreItinerary((0, _filter2.default)(itineraries, function (itinerary) {
      return itinerary.stopsCount === 0;
    }), _sort.SORT_BY_MAP.CHEAPEST.sortBy)
  };
}
function initializeSortState() {
  return (0, _map2.default)((0, _map2.default)((0, _values2.default)(_sort.SORT_BY_MAP), "key"), function (code) {
    return {
      code: code,
      selected: false
    };
  });
}
function getSortPriceDurationHashMap(itineraries) {
  var _ref;
  return _ref = {}, _ref[_sort.SORT_BY_MAP.CHEAPEST.key] = getSortItinerary(itineraries, _sort.SORT_BY_MAP.CHEAPEST.sortBy), _ref[_sort.SORT_BY_MAP.SHORTEST.key] = getSortItinerary(itineraries, _sort.SORT_BY_MAP.SHORTEST.sortBy), _ref[_sort.SORT_BY_MAP.BEST.key] = getSortItinerary(itineraries, _sort.SORT_BY_MAP.BEST.sortBy), _ref[_sort.SORT_BY_MAP.EARLIST_DEPARTURE.key] = getSortItinerary(itineraries, _sort.SORT_BY_MAP.EARLIST_DEPARTURE.sortBy), _ref[_sort.SORT_BY_MAP.LATEST_DEPARTURE.key] = getSortItinerary(itineraries, _sort.SORT_BY_MAP.LATEST_DEPARTURE.sortBy), _ref[_sort.SORT_BY_MAP.EARLIST_ARRIVAL.key] = getSortItinerary(itineraries, _sort.SORT_BY_MAP.EARLIST_ARRIVAL.sortBy), _ref[_sort.SORT_BY_MAP.LATEST_ARRIVAL.key] = getSortItinerary(itineraries, _sort.SORT_BY_MAP.LATEST_ARRIVAL.sortBy), _ref;
}
function getSortItinerary(itineraries, sortKey) {
  return (0, _minBy2.default)(itineraries, sortKey);
}